var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRouterMain = function SvgRouterMain(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 63,
    viewBox: "0 0 71 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.90674 58.3594C2.43096 57.2466 1.58505 54.0654 1.77332 51.6992C1.74509 50.0856 3.3414 41.2003 3.90568 39.6333C4.46998 38.0664 4.76785 36.6247 9.24956 36.4684C17.1335 36.1935 35.9185 36.0441 49.2873 36.5037C55.3261 36.7113 61.6511 37.1944 63.3591 37.3669C67.0295 37.7376 66.9787 40.2193 67.4643 41.943C67.9499 43.6668 68.4035 52.2385 68.4974 53.8213C68.5913 55.404 67.9798 58.9454 63.8898 59.2427C62.0261 59.3782 55.5493 59.4294 46.4957 59.6171C37.4421 59.8048 8.4465 59.9505 4.90674 58.3594Z",
    stroke: "black",
    strokeWidth: 3.25875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79895 58.4317C6.36655 59.6857 22.356 61.2531 35.2887 61.1748C48.2213 61.0964 49.7106 60.5477 64.2892 59.2141",
    stroke: "black",
    strokeWidth: 3.25875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91699 11.4143C15.9537 22.3685 22.9583 34.3899 23.8945 35.9884M63.6953 10.5098C58.1926 19.0967 49.0798 33.2776 46.2116 35.9884",
    stroke: "black",
    strokeWidth: 3.25875,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8213 48.2724C14.1635 48.0689 17.153 48.5075 19.2921 48.2723M24.5317 48.5078C27.8703 48.5078 30.697 48.4933 32.6634 48.5875M37.9984 48.5875C40.1532 48.5875 42.5228 48.5873 45.2591 48.5099",
    stroke: "black",
    strokeWidth: 3.25875,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5591 48.8888C53.2915 48.3838 53.2777 47.1559 54.5813 46.6114C55.5589 46.203 56.42 47.0769 56.6876 47.582C56.9553 48.087 56.8353 49.0624 55.7924 49.498C54.7496 49.9336 53.8268 49.3939 53.5591 48.8888Z",
    stroke: "black",
    strokeWidth: 3.25875
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2254 23.9599C32.4361 22.0214 34.3235 19.3324 37.0607 19.0792C40.8929 18.7247 42.5925 23.5963 39.5497 25.8893C36.507 28.1823 33.4069 25.4518 33.2254 23.9599Z",
    stroke: "black",
    strokeWidth: 3.25875
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1602 11.8341C19.5157 10.5047 22.027 8.0765 25.9478 6.13254C28.1657 5.03287 31.9608 3.6771 36.4458 3.68825C43.377 3.70547 50.0975 6.64777 53.4978 11.272",
    stroke: "black",
    strokeWidth: 3.25875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1386 15.8379C26.8372 14.244 31.0468 11.5887 35.5552 11.5661C42.9576 11.5288 44.7048 12.6908 48.0535 15.6983",
    stroke: "black",
    strokeWidth: 3.25875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRouterMain);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "router_main.e73958c7a569b1b8ad4f87738319cc39.svg";